import { FC } from 'react';
import 'swiper/css/pagination';
import { Swiper, SwiperSlide } from 'swiper/react';
import { SwiperOptions } from 'swiper/types/swiper-options';
import BusinessButton from '../business-button/business-button';
import { COLOR } from '../business-button/business-button.constants';
import CardLifecycle from './card/card-lifecycle';

import styles from './business-hub-carousel-lifecycle.module.scss';

export interface BusinessHubCarouselLifecycleProps {
    title: string;
    subTitle: string;
    autoplay?: boolean;
    backgroundColor: string;
    colorText: string;

    optionButton?: {
        buttonText: string;
        buttonLink: string;
        buttonColor: COLOR;
    };

    items: {
        image: string;
        title: string;
        description: string;
        backgroundContent?: string;
        buttonText?: string;
        buttonLink?: string;
        tileClickable?: boolean;
    }[];
}

const BusinessHubCarouselLifecycle: FC<BusinessHubCarouselLifecycleProps> = (props) => {
    const { title, subTitle, items = [], backgroundColor, colorText, optionButton, autoplay } = props;

    const options: SwiperOptions = {
        spaceBetween: 30,
        allowTouchMove: true,
        slidesPerView: 'auto',
        noSwiping: false,
        pagination: {
            enabled: false,
            clickable: true,
        },

        loop: false,
        speed: 1000,
        autoplay: autoplay
            ? {
                  delay: 4000,
                  disableOnInteraction: false,
                  pauseOnMouseEnter: true,
                  waitForTransition: true,
              }
            : false,

        slidesPerGroupSkip: 0,

        breakpoints: {
            378: {
                slidesPerView: 'auto',
                watchOverflow: true,
                centeredSlides: false,
                spaceBetween: 20,
            },
        },
    };

    return (
        <div
            className={styles.container}
            style={{
                backgroundColor: backgroundColor,
                color: colorText,
            }}
        >
            <div className={styles.wrapperContent}>
                <div className={styles.title} dangerouslySetInnerHTML={{ __html: title || '' }}></div>
                {subTitle && <div className={styles.subTitle}>{subTitle}</div>}

                <div className={styles.listCard}>
                    <Swiper {...options}>
                        {items.map((item, index) => {
                            return (
                                <SwiperSlide key={index}>
                                    <CardLifecycle
                                        image={item.image}
                                        title={item.title}
                                        description={item.description}
                                        backgroundContent={item.backgroundContent}
                                        buttonText={item.buttonText}
                                        buttonLink={item.buttonLink}
                                        tileClickable={item.tileClickable}
                                    />
                                </SwiperSlide>
                            );
                        })}
                    </Swiper>
                </div>

                {optionButton?.buttonText && (
                    <div className={styles.button}>
                        <BusinessButton
                            buttonText={optionButton?.buttonText || 'Learn more'}
                            link={optionButton?.buttonLink || ''}
                            color={optionButton?.buttonColor}
                            target="_blank"
                        ></BusinessButton>
                    </div>
                )}
            </div>
        </div>
    );
};

export default BusinessHubCarouselLifecycle;
